import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Building2, Zap, Heart, Droplets, TrendingDown, Cpu, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const icons = [Building2, Zap, Heart, Droplets, Cpu, TrendingDown];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Values() {
  const {
    t
  } = useLanguage();
  const translatedValues = t('values.items');
  return <section className="relative py-32 px-6 bg-bg-primary overflow-hidden" data-id="element-103">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16 text-center" data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-106">
            {t('values.title')}
          </h2>
          <div className="h-px bg-gold w-24 mx-auto opacity-50" data-id="element-107"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-108">
          {translatedValues.map((val: any, idx: number) => {
          const Icon = icons[idx];
          return <motion.div key={idx} variants={itemVariants} className={`bg-[#1A1A1A] border border-[#222] p-8 hover:-translate-y-2 transition-transform duration-300 ${idx === 3 || idx === 4 ? 'lg:col-span-1' : ''} ${idx === 4 ? 'lg:col-start-2' : ''}`} data-id="element-109">
                <Icon className="w-10 h-10 text-gold mb-6" strokeWidth={1.5} data-id="element-110" />
                <h3 className="text-2xl font-serif text-white mb-4" data-id="element-111">
                  {val.title}
                </h3>
                <p className="text-gray-400 font-light mb-6 leading-relaxed" data-id="element-112">
                  {val.desc}
                </p>
                {val.bullets.length > 0 && <ul className="space-y-3" data-id="element-113">
                    {val.bullets.map((bullet: string, bIdx: number) => <li key={bIdx} className="flex items-start text-gray-300 font-light text-sm" data-id="element-114">
                        <Check className="w-4 h-4 text-gold mr-3 mt-1 shrink-0" data-id="element-115" />
                        <span data-id="element-116">{bullet}</span>
                      </li>)}
                  </ul>}
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}